import jsPDF from "jspdf";
import "../utils/generateReceiptpdf.css";
import paxityLogo from "../../../assets/images/paxitySidebar.png";
import { getStatusConfig } from "./formatStatus";

export const generateReceiptPDF = async ({
  id,
  createdAt,
  paymentMethodName,
  clientNumber,
  prefixPhone,
  amount,
  currency,
  merchantAccountName,
  developerAccountName,
  description,
  transactionReference,
  formatDate,
  status,
  clientFullName
}) => {
  const doc = new jsPDF();

  const statusConfig = getStatusConfig(status);
  const statusLabel = `Paiement${statusConfig.label}`;

  const getBase64FromImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });

  const logoBase64 = await getBase64FromImage(paxityLogo).catch(() => null);

  const primary = [15, 23, 42];
  const lightGray = [240, 242, 245];

  doc.setFillColor(...primary);
  doc.rect(0, 0, 210, 35, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text("Reçu de paiement", 20, 20);

  if (logoBase64) {
    doc.addImage(logoBase64, "PNG", 150, 8, 40, 20);
  }

  doc.setFillColor(240, 249, 255);
  doc.roundedRect(20, 45, 170, 30, 5, 5, "F");

  doc.setTextColor(100);
  doc.setFontSize(12);
  doc.text("Montant payé", 25, 58);

  doc.setTextColor(0, 102, 204);
  doc.setFontSize(18);
  doc.text(`${amount?.toLocaleString()} ${currency}`, 25, 68);

  let startY = 90;

  const drawRow = (label, value, isAlt) => {
    if (isAlt) {
      doc.setFillColor(...lightGray);
      doc.rect(20, startY - 6, 170, 10, "F");
    }

    doc.setTextColor(120);
    doc.setFontSize(11);
    doc.text(label, 25, startY);

    doc.setTextColor(0);
    doc.text(value || "-", 110, startY);

    startY += 10;
  };

  let alt = false;

  drawRow("Bénéficiaire", merchantAccountName, (alt = !alt));
  drawRow("Business", developerAccountName, (alt = !alt));

  drawRow(
    paymentMethodName === "BANK" ? "Numéro Compte" : "Téléphone",
    `${paymentMethodName !== "BANK" ? "+" : ""}${prefixPhone} ${clientNumber}`,
    (alt = !alt)
  );

  drawRow("Date", formatDate(createdAt), (alt = !alt));

  drawRow(
    "Moyen de paiement",
    paymentMethodName === "BANK"
      ? "Virement bancaire"
      : paymentMethodName === "WAVESN"
      ? "Wave"
      : paymentMethodName === "OMSN"
      ? "Orange Money"
      : "Non défini",
    (alt = !alt)
  );

  if (description) drawRow("Description", description, (alt = !alt));
  if (transactionReference) drawRow("Référence", transactionReference, (alt = !alt));
  if (clientFullName) drawRow("Client", clientFullName, (alt = !alt));

  doc.setFillColor(...statusConfig.bgColor);
  doc.roundedRect(20, startY + 10, 80, 12, 3, 3, "F");

  doc.setTextColor(...statusConfig.textColor);
  doc.setFontSize(11);
  doc.text(statusLabel, 25, startY + 18);

  doc.setDrawColor(220);
  doc.line(20, 270, 190, 270);

  doc.setFontSize(10);
  doc.setTextColor(120);
  doc.text("Merci pour votre confiance", 20, 280);

  doc.setTextColor(0, 102, 204);
  doc.text("www.portail.paxity.io", 140, 280);

  doc.save(`Recu-Versement-Paxity-${id}.pdf`);
};